import React, { useState } from "react";
import WebHeader from "../WebHeader/WebHeader";
import Sidebar from "../Sidebar/Sidebar";
import WebFooter from "../WebFooter/WebFooter";
import { Link, useLocation } from "react-router-dom";
import "../Login/Home.css";

const EditCareerApplication = () => {
  const location = useLocation();
  const applicationDetails = location.state?.applicationDetails || {};

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  const calculateAge = (dob) => {
    if (!dob) return "";
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const age = calculateAge(applicationDetails.date_of_birth);

  const [formData, setFormData] = useState({
    full_name: applicationDetails.full_name || "",
    contact_number: applicationDetails.contact_number || "",
    gender: applicationDetails.gender || "",
    emailID: applicationDetails.email || "",
    available_from: formatDateForInput(applicationDetails.available_from),
    timestamp: formatDateForInput(applicationDetails.timestamp),
    date_of_birth: formatDateForInput(applicationDetails.date_of_birth),
    nationality: applicationDetails.nationality || "",
    address: applicationDetails.address || "",
    marital_status: applicationDetails.marital_status || "",
    kids: applicationDetails.kids || "",
    major_illness: applicationDetails.major_illness || "",
    company_name: applicationDetails.company_name || "",
    position_held: applicationDetails.position_held || "",
    reason_for_leaving: applicationDetails.reason_for_leaving || "",
    employement_period: applicationDetails.employement_period || "",
    supervisor_name: applicationDetails.supervisor_name || "",
    supervisor_contact: applicationDetails.supervisor_contact || "",
    education: applicationDetails.education
      ? applicationDetails.education.map((edu) => ({
          id: edu.id || "",
          degree: edu.degree || "",
          institution: edu.institution || "",
          year_of_completion: edu.year_of_completion || "",
        }))
      : [],
    work_arrangement: applicationDetails.work_arrangement || "",
    salary_drawn: applicationDetails.salary_drawn || "",
    salary_expected: applicationDetails.salary_expected || "",
    current_position: applicationDetails.current_position || "",
    english: applicationDetails.english_level || "",
    hindi: applicationDetails.hindi_level || "",
    gujarati: applicationDetails.gujarati_level || "",
    references: applicationDetails.references
      ? applicationDetails.references.map((ref) => ({
          id: ref.id || "",
          name: ref.name || "",
          position: ref.position || "",
          company: ref.company || "",
          contact_number: ref.contact_number || "",
        }))
      : [],
    hospitality_experience: applicationDetails.hospitality_experience || "",
    desc_hospitality: applicationDetails.desc_hospitality || "",
    years_in_hospitality: applicationDetails.years_in_hospitality || "",
    legal_authorization: applicationDetails.legal_authorization || "",
    related_to_company: applicationDetails.related_to_company || "",
    related_details: applicationDetails.related_details || "",
    criminal_record: applicationDetails.criminal_record || "",
    desc_criminal: applicationDetails.desc_criminal || "",
    checkIn: applicationDetails.checkIn || "",
    checkOut: applicationDetails.checkOut || "",
    childAccompanying: applicationDetails.childAccompanying || "",
    bookRide: applicationDetails.bookRide || "",
    price: applicationDetails.price || "",
    taxes: applicationDetails.taxes || "",
    specialRequest: applicationDetails.specialRequest || "",
    name: applicationDetails.name || "",
    phone: applicationDetails.phone || "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="bg-[#F8F6F6] text-[14px] leading-6 print:bg-white">
      <div className="not-print print:hidden">
        <WebHeader />
      </div>

      <div className="hidden lg:block">
        <Sidebar />
      </div>
      <br className="print:hidden" />

      <div className="mt-[70px] mx-[3%] lg:ml-[23%] print:mt-0 print:mx-0 print:ml-0">
        <div className="print:hidden">
          <Link
            to="/CareerApplications"
            className="text-[#008080] hover:underline"
          >
            Go Back
          </Link>
        </div>

        <div className="bg-white rounded-lg p-[3%] lg:p-[2%] mb-[2vw] print:bg-white print:rounded-none print:p-8 print:mb-0">
          {/* Printable Header - adjusted top spacing */}
          <div className="hidden print:flex print:flex-col sm:print:flex-row print:justify-between print:items-start print:mb-4 print:pt-4">
            <div className="mb sm:mb-0">
              <img
                src="../assets/new_rpj_hotel_logo.webp"
                className="w-32 h-auto"
                alt="Company Logo"
              />
            </div>
            <div>
              <p className="text-sm text-right text-gray-700">
                Kalavad Rd, Near Everest Park, Jai Bhimnagar, <br />
                Nana Mava, Rajkot, Gujarat 360005.
                <br />
                <a href="mailto:hr@rpjhotels.com">www.rpjhotels.com </a>
                <a href="mailto:hr@rpjhotels.com"> hr@rpjhotels.com</a>
              </p>
            </div>
          </div>

          {/* Printable Section */}
          <div className="max-w-5xl mx-auto bg-white p-2 print:max-w-none print:mx-0 print:px-4 print:py-2">
            {/* Form Header */}
            <div className="flex justify-between items-center text-sm">
              <p className="font-bold text-lg">APPLICATION</p>

              <div className="text-xs">
                <label>Date of Application:</label>
                <input
                  type="date"
                  className="px-2 py-1 border-none focus:outline-none w-[105px]"
                  name="timestamp"
                  value={formData.timestamp}
                  onChange={handleInputChange}
                  readOnly
                />
              </div>
            </div>
            <hr className="my-[2%]" />

            <div className="space-y-2 print:min-h-screen print:flex print:flex-col print:justify-between">
              <div className="space-y-2">
                {/* Personal Information Section */}
                <div className="space-y-3">
                  <h2 className="font-semibold text-gray-500">
                    PERSONAL INFORMATION
                  </h2>

                  {/* Full Name */}
                  <div className="flex items-center w-full gap-2">
                    <label className="font-semibold whitespace-nowrap min-w-fit">
                      Full Name:
                    </label>
                    <div className="flex-grow border-b border-gray-400">
                      <input
                        type="text"
                        className="w-full bg-transparent outline-none px-2"
                        name="full_name"
                        value={formData.full_name}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Gender & Phone */}
                  <div className="flex flex-wrap justify-between items-center w-full gap-2">
                    <div className="flex items-center gap-5">
                      <span className="font-semibold min-w-fit">Gender:</span>

                      <div className="flex items-center gap-10">
                        {["Male", "Female"].map((option) => (
                          <label
                            key={option}
                            className="flex items-center gap-2"
                          >
                            <input
                              type="radio"
                              required
                              name="gender"
                              value={option}
                              checked={formData.gender === option}
                              readOnly
                              className="print_radioBtn w-4 h-4"
                            />
                            {option}
                          </label>
                        ))}
                      </div>
                    </div>

                    <div className="flex items-center">
                      <label className="font-semibold mr-2 min-w-fit">
                        Phone:
                      </label>
                      <input
                        type="text"
                        className="border-b border-gray-400 px-2 outline-none w-full"
                        name="contact_number"
                        value={formData.contact_number}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Marital Status, Kids, DOB and Age */}
                  <div className="flex flex-wrap justify-between items-center w-full gap-2">
                    <div className="flex items-center gap-5">
                      <span className="font-semibold min-w-fit">
                        Marital Status:
                      </span>
                      <div className="flex items-center gap-5">
                        {["Yes", "No"].map((option) => (
                          <label
                            key={option}
                            className="flex items-center gap-2"
                          >
                            <input
                              type="radio"
                              required
                              name="marital_status"
                              value={option}
                              checked={formData.marital_status === option}
                              readOnly
                              className="print_radioBtn w-4 h-4"
                            />
                            {option}
                          </label>
                        ))}
                      </div>
                    </div>

                    <div className="flex items-center gap-5">
                      <span className="font-semibold min-w-fit">Kids:</span>
                      <div className="flex items-center gap-5">
                        {["Yes", "No"].map((option) => (
                          <label
                            key={option}
                            className="flex items-center gap-2"
                          >
                            <input
                              type="radio"
                              required
                              name="kids"
                              value={option}
                              checked={formData.kids === option}
                              readOnly
                              className="print_radioBtn w-4 h-4"
                            />
                            {option}
                          </label>
                        ))}
                      </div>
                    </div>

                    <div className="flex items-center gap-1">
                      <label className="font-semibold min-w-fit">DOB:</label>
                      <input
                        type="date"
                        className="border-b border-gray-400 px-2 py-1 outline-none text-center"
                        name="date_of_birth"
                        value={formData.date_of_birth}
                        readOnly
                      />
                    </div>

                    <div className="flex items-center gap-1">
                      <label className="font-semibold min-w-fit">Age:</label>
                      <input
                        type="text"
                        className="border-b border-gray-400 px-2 py-1 outline-none w-16 text-center"
                        value={age}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Address */}
                  <div className="flex items-center gap-2">
                    <label className="font-semibold min-w-fit">Address:</label>
                    <input
                      type="text"
                      className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                      name="address"
                      value={formData.address}
                      readOnly
                    />
                  </div>

                  {/* Email */}
                  <div className="flex items-center gap-2">
                    <label className="font-semibold whitespace-nowrap min-w-fit">
                      Email:
                    </label>
                    <input
                      type="text"
                      className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                      name="emailID"
                      value={formData.emailID}
                      readOnly
                    />
                  </div>

                  {/* Nationality */}
                  <div className="flex items-center gap-2">
                    <label className="font-semibold whitespace-nowrap min-w-fit">
                      Nationality:
                    </label>
                    <input
                      type="text"
                      className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                      name="nationality"
                      value={formData.nationality}
                      readOnly
                    />
                  </div>

                  {/* Illness History */}
                  <div className="flex flex-col gap-1">
                    <div className="flex flex-wrap items-center gap-5">
                      <span className="font-semibold min-w-fit">
                        Any major illness/operation during the last three years:
                      </span>

                      <div className="flex items-center gap-20">
                        {["Yes", "No"].map((option) => (
                          <label
                            key={option}
                            className="flex items-center gap-2"
                          >
                            <input
                              type="radio"
                              required
                              name="major_illness"
                              value={option}
                              checked={formData.major_illness === option}
                              readOnly
                              className="print_radioBtn w-4 h-4"
                            />
                            {option}
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Employment History */}
                <div className="space-y-3 print:page-break-inside-avoid">
                  <h2 className="font-semibold text-gray-500 mt-8">
                    EMPLOYMENT HISTORY
                  </h2>
                  {/* Company Name */}
                  <div className="flex flex-col lg:flex-row justify-between items-center gap-3 lg:gap-10 w-full">
                    <div className="flex items-center gap-2 w-full">
                      <label className="font-semibold min-w-fit">
                        Company Name:
                      </label>
                      <input
                        type="text"
                        className="border-b border-gray-400 px-2 py-1 outline-none w-full"
                        name="company_name"
                        value={formData.company_name}
                        readOnly
                      />
                    </div>

                    <div className="flex items-center gap-2 w-full">
                      <label className="font-semibold min-w-fit">
                        Position Held:
                      </label>
                      <input
                        type="text"
                        className="border-b border-gray-400 px-2 py-1 outline-none w-full"
                        name="position_held"
                        value={formData.position_held}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Position & Reason for Leaving */}
                  <div className="flex items-center gap-2 w-full sm:w-auto overflow-hidden sm:overflow-x-scroll">
                    <label className="font-semibold min-w-fit">
                      Reason for Leaving:
                    </label>
                    <input
                      type="text"
                      className="border-b border-gray-400 px-2 py-1 outline-none flex-grow"
                      name="reason_for_leaving"
                      value={formData.reason_for_leaving}
                      readOnly
                    />
                  </div>

                  {/* Employment Period */}
                  <div className="flex flex-wrap items-center gap-2">
                    <label className="font-semibold min-w-fit">
                      Employment Period:
                    </label>
                    <input
                      type="text"
                      className="px-2 py-1 border-gray-400 border-b focus:outline-none"
                      name="employement_period"
                      value={formData.employement_period}
                      readOnly
                    />
                  </div>

                  {/* Supervisor's Name & Contact */}
                  <div className="flex flex-col lg:flex-row justify-between items-center gap-3 lg:gap-10 w-full">
                    <div className="flex items-center gap-2 w-full">
                      <label className="font-semibold min-w-fit">
                        Supervisor's Name:
                      </label>
                      <input
                        type="text"
                        className="border-b border-gray-400 px-2 py-1 outline-none w-full"
                        name="supervisor_name"
                        value={formData.supervisor_name}
                        readOnly
                      />
                    </div>

                    <div className="flex items-center gap-2 w-full">
                      <label className="font-semibold min-w-fit">
                        Supervisor's Contact:
                      </label>
                      <input
                        type="text"
                        className="border-b border-gray-400 px-2 py-1 outline-none w-full"
                        name="supervisor_contact"
                        value={formData.supervisor_contact}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                {/* Educational Background */}
                <div className="space-y-3 print:page-break-inside-avoid">
                  <h2 className="font-semibold text-gray-500 mt-8">
                    Educational Background:
                  </h2>

                  {/* Table for larger screens */}
                  <div className="hidden sm:block mb-5">
                    {/* Table Header */}
                    <div className="flex gap-8 font-semibold text-gray-800">
                      <div className="w-1/3">Degree</div>
                      <div className="w-1/3">Institution</div>
                      <div className="w-1/3">Year of Completion</div>
                    </div>

                    {/* Input Fields (Multiple Rows) */}
                    <div className="space-y-3">
                      {formData.education.map((edu, index) => (
                        <div key={edu.id || index} className="flex gap-2">
                          <div className="w-1/3 border-b border-gray-400">
                            <input
                              type="text"
                              className="w-full bg-transparent outline-none px-2"
                              name="degree"
                              value={edu.degree}
                              readOnly
                            />
                          </div>
                          <div className="w-1/3 border-b border-gray-400">
                            <input
                              type="text"
                              className="w-full bg-transparent outline-none px-2"
                              name="institution"
                              value={edu.institution}
                              readOnly
                            />
                          </div>
                          <div className="w-1/3 border-b border-gray-400">
                            <input
                              type="text"
                              className="w-full bg-transparent outline-none px-2"
                              name="year_of_completion"
                              value={edu.year_of_completion}
                              readOnly
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Responsive layout for small screens */}
                  <div className="sm:hidden space-y-8">
                    {formData.education.map((edu, index) => (
                      <div key={edu.id || index} className="space-y-2">
                        <div className="flex items-center gap-2">
                          <label className="font-semibold w-32">Degree:</label>
                          <input
                            type="text"
                            className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                            name="degree"
                            value={edu.degree}
                            readOnly
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <label className="font-semibold w-32">
                            Institution:
                          </label>
                          <input
                            type="text"
                            className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                            name="institution"
                            value={edu.institution}
                            readOnly
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <label className="font-semibold w-32">Year:</label>
                          <input
                            type="text"
                            className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                            name="year_of_completion"
                            value={edu.year_of_completion}
                            readOnly
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* AVAILABILITY & PREFERRED WORK SCHEDULE */}
                <div className="space-y-3 print:page-break-inside-avoid">
                  <h2 className="font-semibold text-gray-500 mt-8">
                    AVAILABILITY & PREFERRED WORK SCHEDULE
                  </h2>

                  {/* Start Date & Work Type */}
                  <div className="flex flex-wrap items-center gap-2 justify-between">
                    <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
                      <label className="font-semibold min-w-fit">
                        Available to Start Work From:
                      </label>
                      <input
                        type="date"
                        className="px-2 py-1 border-b border-gray-400 focus:outline-none"
                        name="available_from"
                        value={formData.available_from}
                        readOnly
                      />
                    </div>

                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                      {[
                        "Full-Time",
                        "Part-Time",
                        "Temporary",
                        "Shift Work",
                      ].map((option) => (
                        <label key={option} className="flex items-center gap-2">
                          <input
                            type="radio"
                            required
                            className="print_radioBtn w-4 h-4"
                            name="work_arrangement"
                            value={option}
                            checked={formData.work_arrangement === option}
                            readOnly
                          />
                          {option}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Salary Drawn & Expected */}
                  <div className="flex flex-wrap items-center gap-2 md:gap-10 overflow-hidden">
                    <div className="flex items-center gap-2 w-full sm:w-auto">
                      <label className="font-semibold min-w-fit">
                        Salary Drawn:
                      </label>
                      <input
                        type="text"
                        className="border-b border-gray-400 px-2 py-1 outline-none flex-grow"
                        name="salary_drawn"
                        value={formData.salary_drawn}
                        readOnly
                      />
                    </div>

                    <div className="flex items-center gap-2 w-full sm:w-auto">
                      <label className="font-semibold min-w-fit">
                        Salary Expected:
                      </label>
                      <input
                        type="text"
                        className="border-b border-gray-400 px-2 py-1 outline-none flex-grow"
                        name="salary_expected"
                        value={formData.salary_expected}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Current Position */}
                  <div className="flex items-center flex-wrap">
                    <label className="font-semibold min-w-fit">
                      Current Position:
                    </label>
                    <input
                      type="text"
                      className="border-b border-gray-400 px-2 py-1 outline-none flex-grow"
                      name="current_position"
                      value={formData.current_position}
                      readOnly
                    />
                  </div>
                </div>

                {/* PROFESSIONAL QUALIFICATIONS & CERTIFICATIONS LANGUAGE PROFICIENCY */}
                <div className="space-y-3 print:page-break-inside-avoid">
                  <h2 className="font-semibold text-gray-500 mt-8">
                    PROFESSIONAL QUALIFICATIONS & CERTIFICATIONS LANGUAGE
                    PROFICIENCY
                  </h2>

                  {/* English Proficiency */}
                  <div className="flex flex-wrap items-center w-full gap-2">
                    <span className="font-semibold min-w-fit w-24">
                      English:
                    </span>
                    <div className="flex flex-wrap items-center gap-5">
                      {["No", "Basic", "Intermediate", "Fluent"].map(
                        (level) => (
                          <label
                            key={level}
                            className="flex items-center gap-1"
                          >
                            <input
                              type="radio"
                              name="english"
                              value={level}
                              checked={formData.english === level}
                              readOnly
                              className="print_radioBtn"
                            />
                            <span>{level}</span>
                          </label>
                        )
                      )}
                    </div>
                  </div>

                  {/* Hindi Proficiency */}
                  <div className="flex flex-wrap items-center w-full gap-2">
                    <span className="font-semibold min-w-fit w-24">Hindi:</span>
                    <div className="flex flex-wrap items-center gap-5">
                      {["No", "Basic", "Intermediate", "Fluent"].map(
                        (level) => (
                          <label
                            key={level}
                            className="flex items-center gap-1"
                          >
                            <input
                              type="radio"
                              name="hindi"
                              value={level}
                              checked={formData.hindi === level}
                              readOnly
                              className="print_radioBtn"
                            />
                            <span>{level}</span>
                          </label>
                        )
                      )}
                    </div>
                  </div>

                  {/* Gujarati Proficiency */}
                  <div className="flex flex-wrap items-center w-full gap-2">
                    <span className="font-semibold min-w-fit w-24">
                      Gujarati:
                    </span>
                    <div className="flex flex-wrap items-center gap-5">
                      {["No", "Basic", "Intermediate", "Fluent"].map(
                        (level) => (
                          <label
                            key={level}
                            className="flex items-center gap-1"
                          >
                            <input
                              type="radio"
                              name="gujarati"
                              value={level}
                              checked={formData.gujarati === level}
                              readOnly
                              className="print_radioBtn"
                            />
                            <span>{level}</span>
                          </label>
                        )
                      )}
                    </div>
                  </div>
                </div>

                {/* REFERENCES (Provide two professional references) */}
                <div className="space-y-3 print:page-break-inside-avoid">
                  <h2 className="font-semibold text-gray-500 mt-8">
                    REFERENCES
                  </h2>

                  {/* Table for larger screens */}
                  <div className="hidden sm:block">
                    {/* Table Header */}
                    <div className="flex gap-8 font-semibold text-gray-800">
                      <div className="w-1/4">Name</div>
                      <div className="w-1/4">Position</div>
                      <div className="w-1/4">Company</div>
                      <div className="w-1/4">Contact Number</div>
                    </div>

                    {/* Input Fields (Multiple Rows) */}
                    <div className="space-y-3">
                      {formData.references.map((ref, index) => (
                        <div key={ref.id || index} className="flex gap-2">
                          <div className="w-1/4 border-b border-gray-400">
                            <input
                              type="text"
                              className="w-full bg-transparent outline-none px-2"
                              name="name"
                              value={ref.name}
                              readOnly
                            />
                          </div>
                          <div className="w-1/4 border-b border-gray-400">
                            <input
                              type="text"
                              className="w-full bg-transparent outline-none px-2"
                              name="position"
                              value={ref.position}
                              readOnly
                            />
                          </div>
                          <div className="w-1/4 border-b border-gray-400">
                            <input
                              type="text"
                              className="w-full bg-transparent outline-none px-2"
                              name="company"
                              value={ref.company}
                              readOnly
                            />
                          </div>
                          <div className="w-1/4 border-b border-gray-400">
                            <input
                              type="text"
                              className="w-full bg-transparent outline-none px-2"
                              name="contact_number"
                              value={ref.contact_number}
                              readOnly
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Responsive layout for small screens */}
                  <div className="sm:hidden space-y-4">
                    {formData.references.map((ref, index) => (
                      <div
                        key={index}
                        className="space-y-2 border-b border-gray-200 pb-4"
                      >
                        <div className="flex items-center gap-2">
                          <label className="font-semibold w-32">Name:</label>
                          <input
                            type="text"
                            className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                            value={ref.name}
                            readOnly
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <label className="font-semibold w-32">
                            Position:
                          </label>
                          <input
                            type="text"
                            className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                            value={ref.position}
                            readOnly
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <label className="font-semibold w-32">Company:</label>
                          <input
                            type="text"
                            className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                            value={ref.company}
                            readOnly
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <label className="font-semibold w-32">Contact:</label>
                          <input
                            type="text"
                            className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                            value={ref.contact_number}
                            readOnly
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* ADDITIONAL INFORMATION */}
                <div className="space-y-3 print:page-break-inside-avoid">
                  <h2 className="font-semibold text-gray-500 mt-8">
                    ADDITIONAL INFORMATION
                  </h2>

                  {/* Hospitality Industry Experience */}
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-semibold min-w-fit">
                      Do you have any experience in the hospitality industry?
                    </span>
                    <div className="flex items-center gap-4">
                      {["Yes", "No"].map((option) => (
                        <label key={option} className="flex items-center gap-2">
                          <input
                            type="radio"
                            className="print_radioBtn w-4 h-4"
                            name="hospitality_experience"
                            value={option}
                            checked={formData.hospitality_experience === option}
                            readOnly
                          />
                          {option}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Describe Hospitality Experience */}
                  {formData.hospitality_experience === "Yes" && (
                    <div className="flex flex-col md:flex-row md:items-center gap-2">
                      <label className="font-semibold min-w-fit">
                        If yes, please describe:
                      </label>
                      <input
                        type="text"
                        className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                        name="desc_hospitality"
                        value={formData.desc_hospitality}
                        readOnly
                      />
                    </div>
                  )}

                  {/* Legally Authorized to Work */}
                  <div className="flex flex-wrap items-center w-full gap-5">
                    <span className="font-semibold min-w-fit">
                      Are you legally authorized to work in this country?
                    </span>
                    <div className="flex items-center gap-4">
                      {["Yes", "No"].map((option) => (
                        <label key={option} className="flex items-center gap-2">
                          <input
                            type="radio"
                            name="legal_authorization"
                            value={option}
                            checked={formData.legal_authorization === option}
                            readOnly
                            className="print_radioBtn w-4 h-4"
                          />
                          {option}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Convicted of a Crime */}
                  <div className="flex flex-wrap items-center w-full gap-2">
                    <span className="font-semibold min-w-fit">
                      Have you ever been convicted of a crime or are you under
                      any legal issues?
                    </span>
                    <div className="flex items-center gap-2">
                      {["Yes", "No"].map((option) => (
                        <label key={option} className="flex items-center gap-2">
                          <input
                            type="radio"
                            className="print_radioBtn w-4 h-4"
                            name="criminal_record"
                            value={option}
                            checked={formData.criminal_record === option}
                            readOnly
                          />
                          {option}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Details of Crime */}
                  {formData.criminal_record === "Yes" && (
                    <div className="flex flex-col md:flex-row md:items-center gap-2">
                      <label className="font-semibold min-w-fit">
                        If yes, please details:
                      </label>
                      <input
                        type="text"
                        className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                        name="desc_criminal"
                        value={formData.desc_criminal}
                        readOnly
                      />
                    </div>
                  )}

                  {/* Related to Anyone in the Group */}
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-semibold min-w-fit">
                      Are you related/known to anyone in our group of concern?
                    </span>
                    <div className="flex items-center gap-2">
                      {["Yes", "No"].map((option) => (
                        <label key={option} className="flex items-center gap-2">
                          <input
                            type="radio"
                            className="print_radioBtn w-4 h-4"
                            name="related_to_company"
                            value={option}
                            checked={formData.related_to_company === option}
                            readOnly
                          />
                          {option}
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Details of Relation */}
                  {formData.related_to_company === "Yes" && (
                    <div className="flex flex-col md:flex-row md:items-center gap-2">
                      <label className="font-semibold min-w-fit">
                        If yes, please details:
                      </label>
                      <input
                        type="text"
                        className="flex-grow border-b border-gray-400 px-2 py-1 outline-none"
                        name="related_details"
                        value={formData.related_details}
                        readOnly
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Footer Section - Will always be at the bottom when printing */}
              <div className="hidden print:flex print:flex-col sm:print:flex-row print:justify-between print:items-center print:mt-auto print:pb-8 print:pt-8 print:border-t print:border-gray-200">
                <div className="w-full sm:w-2/5 mb-4 sm:mb-0">
                  <span className="font-bold">APPLICANT'S DECLARATION:</span>
                  <p className="text-sm text-gray-700 mt-1">
                    I certify that all information provided in this application
                    is true and complete to the best of my knowledge. I
                    understand that any false statements may result in
                    disqualification or termination if employed.
                  </p>
                </div>

                <div className="flex justify-end">
                  <div className="w-52 text-right">
                    <div className="border-t border-gray-400 mt-2">
                      <span className="text-sm">Signature</span>
                    </div>
                    <div className="mt-2">
                      <span className="font-semibold">
                        Date: __ / __ / _____
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Added 'print:hidden' to hide this div when printing */}
              <div className="print:hidden text-right mt-4 mb-8">
                <button
                  onClick={handlePrint}
                  className="bg-[#008080] text-white px-4 py-2 rounded hover:bg-teal-700 transition-colors"
                >
                  Print Application
                </button>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div className="not-print print:hidden lg:-ml-[350px]">
          <WebFooter />
        </div>
      </div>
    </div>
  );
};

export default EditCareerApplication;
